import SecuritiesReportEmployeeStatus from './SecuritiesReportEmployeeStatus'

/** @type {Record<string, React.ComponentType<object>>} */
export const CUSTOM_DASHBOARD_COMPONENTS = {
  '10.6.1': SecuritiesReportEmployeeStatus
}

/**
 * @param {string | undefined | null} key
 * @returns {boolean}
 */
export function isCustomDashboard(key) {
  return Boolean(key && key in CUSTOM_DASHBOARD_COMPONENTS)
}

/**
 * @param {string} key
 * @returns {React.ComponentType<object> | null}
 */
export function getCustomDashboardComponent(key) {
  return CUSTOM_DASHBOARD_COMPONENTS[key] ?? null
}
